var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLev3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 376 178",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fae757;\n      }\n\n      .cls-2 {\n        fill: #4d3423;\n      }\n\n      .cls-3 {\n        stroke: #002131;\n        stroke-linecap: round;\n      }\n\n      .cls-3, .cls-4 {\n        fill: none;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .cls-5 {\n        fill: #cc8f70;\n      }\n\n      .cls-6 {\n        fill: #414a4c;\n      }\n\n      .cls-7 {\n        fill: #eeb68c;\n      }\n\n      .cls-8 {\n        fill: #bfa776;\n      }\n\n      .cls-9 {\n        fill: #dba276;\n      }\n\n      .cls-10 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-11 {\n        fill: #4eadad;\n      }\n\n      .cls-12 {\n        fill: #e6eef2;\n      }\n\n      .cls-13 {\n        fill: #fff;\n      }\n\n      .cls-14 {\n        fill: #348493;\n      }\n\n      .cls-15 {\n        fill: #cfb580;\n      }\n\n      .cls-16 {\n        fill: #eb986d;\n      }\n\n      .cls-17 {\n        fill: #edb58c;\n      }\n\n      .cls-18 {\n        fill: #a69166;\n      }\n\n      .cls-19 {\n        fill: #6fe8dd;\n      }\n\n      .cls-4 {\n        stroke: #4eadad;\n      }\n\n      .cls-20 {\n        fill: #65442e;\n      }\n\n      .cls-21 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M265.76,25.52h34.51c10.79,0,19.55,8.76,19.55,19.55v48.71c0,16.83-13.67,30.5-30.5,30.5h-12.62c-16.83,0-30.5-13.67-30.5-30.5v-48.71c0-10.79,8.76-19.55,19.55-19.55Z",
    transform: "translate(357.92 -208.12) rotate(90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M45.51,4.26h104.02c7.67,0,13.9,6.23,13.9,13.9v99.08c0,16.36-13.29,29.65-29.65,29.65H61.26c-16.36,0-29.65-13.29-29.65-29.65V18.15c0-7.67,6.23-13.9,13.9-13.9Z",
    transform: "translate(173.08 -21.95) rotate(90)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Calque_3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 196,
    cy: 131,
    rx: 174,
    ry: 35
  })), /*#__PURE__*/React.createElement("g", {
    id: "Calque_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M245.23,92.17h98.52v35.25c0,10.1-8.2,18.3-18.3,18.3h-61.91c-10.1,0-18.3-8.2-18.3-18.3v-35.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M339.13,118.21c5.6,0,10.42-3.31,12.64-8.07,6.09-1.5,10.62-6.98,10.62-13.53,0-.24-.02-.48-.04-.71,3.08-1.61,5.18-4.83,5.18-8.54,0-1.35-.28-2.63-.78-3.8,1.78-2.97,2.82-6.42,2.82-10.13,0-4.45-1.49-8.55-3.98-11.85,1.21-1.61,1.93-3.61,1.93-5.78,0-4.19-2.67-7.74-6.4-9.08.37-1.23.58-2.54.58-3.89,0-7.06-5.42-12.84-12.33-13.44-1.97-4.29-6.28-7.27-11.31-7.27-4.1,0-7.73,1.99-10,5.05-1.11-.55-2.35-.87-3.67-.87-4.56,0-8.26,3.7-8.26,8.26,0,3.59,2.29,6.63,5.49,7.77-2.1,2.59-3.37,5.89-3.37,9.48,0,4.18,1.7,7.95,4.45,10.68-3.96,2.65-6.56,7.17-6.56,12.29s2.53,9.5,6.4,12.17c-2.31,2.37-3.85,5.49-4.2,8.97-1.36,1.47-2.2,3.43-2.2,5.6,0,4.56,3.7,8.26,8.26,8.26.09,0,.17-.01.26-.01.72.51,1.5.95,2.31,1.33,2.39,4.24,6.93,7.11,12.15,7.11Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 238.73,
    cy: 127.44,
    r: 15.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 219.34,
    y: 122.04,
    width: 16.81,
    height: 18.24,
    transform: "translate(427.23 -39.94) rotate(109.44)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 179.53,
    y: 76.41,
    width: 25.17,
    height: 54.27,
    rx: 12.58,
    ry: 12.58,
    transform: "translate(370.86 228.76) rotate(-173.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M191.79,98.8h16.33c2.44,0,4.42,1.98,4.42,4.42v28.11c0,6.95-5.64,12.58-12.58,12.58h0c-6.95,0-12.58-5.64-12.58-12.58v-28.11c0-2.44,1.98-4.42,4.42-4.42Z",
    transform: "translate(380.95 -26.81) rotate(109.44)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 104.29,
    y: 70.96,
    width: 70.77,
    height: 27.06,
    rx: 13.53,
    ry: 13.53,
    transform: "translate(-18.84 123.51) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M101.06,69.71h11.66c4.41,0,7.98,3.58,7.98,7.98v39.57c0,7.47-6.06,13.53-13.53,13.53h0c-7.47,0-13.53-6.06-13.53-13.53v-40.13c0-4.1,3.33-7.42,7.42-7.42Z",
    transform: "translate(6.92 207.42) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M64,94.09h23.41c4.15,0,7.51,3.37,7.51,7.51v4.66c0,2.21-1.79,4.01-4.01,4.01h-22.92c-2.21,0-4.01-1.79-4.01-4.01v-12.17h0Z",
    transform: "translate(181.64 22.72) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M51.86,101.92h30.27c5.36,0,9.71,4.35,9.71,9.71h0c0,2.08-1.69,3.77-3.77,3.77h-36.2c-2.16,0-3.92-1.76-3.92-3.92v-5.64c0-2.16,1.76-3.92,3.92-3.92Z",
    transform: "translate(178.55 38.78) rotate(90)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 117.41,
    y: 47.02,
    width: 70.77,
    height: 27.06,
    rx: 13.53,
    ry: 13.53,
    transform: "translate(1.93 125.78) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M113.78,45.46h11.66c4.41,0,7.98,3.58,7.98,7.98v39.57c0,7.47-6.06,13.53-13.53,13.53h0c-7.47,0-13.53-6.06-13.53-13.53v-40.13c0-4.1,3.33-7.42,7.42-7.42Z",
    transform: "translate(43.88 195.88) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M76.71,69.84h23.65c4.02,0,7.28,3.26,7.28,7.28v4.9c0,2.21-1.79,4.01-4.01,4.01h-22.92c-2.21,0-4.01-1.79-4.01-4.01v-12.17h0Z",
    transform: "translate(170.11 -14.25) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M64.57,77.67h30.27c5.36,0,9.71,4.35,9.71,9.71h0c0,2.08-1.69,3.77-3.77,3.77h-36.2c-2.16,0-3.92-1.76-3.92-3.92v-5.64c0-2.16,1.76-3.92,3.92-3.92Z",
    transform: "translate(167.02 1.82) rotate(90)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M167.54,64.32l-17.65,18.15c-4.39,4.51-10.41,7.06-16.71,7.06h-32.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M171.19,22.77h41.72c10.03,0,18.17,8.14,18.17,18.17v60.7h-78.06v-60.7c0-10.03,8.14-18.17,18.17-18.17Z",
    transform: "translate(254.26 -129.84) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M231.44,81.09c-6.55,0-11.86-5.31-11.86-11.86v-7.03s0-7.03,0-7.03c0-6.55,5.31-11.86,11.86-11.86h0v37.77h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M282.97,93.94l1.36-52.16c0-6.48,5.3-11.78,11.78-11.78h28.12c10.24,0,18.62,8.38,18.62,18.62l-1.36,38.48c0,10.24-8.38,18.62-18.62,18.62h-28.12c-6.48,0-11.78-5.3-11.78-11.78Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 223.64,
    y: 51.75,
    width: 30.41,
    height: 20.91,
    transform: "translate(301.06 -176.64) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M265.76,25.52h34.51c10.79,0,19.55,8.76,19.55,19.55v48.71c0,16.83-13.67,30.5-30.5,30.5h-12.62c-16.83,0-30.5-13.67-30.5-30.5v-48.71c0-10.79,8.76-19.55,19.55-19.55Z",
    transform: "translate(357.92 -208.12) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M276.02,121.87v-9.2c0-5.34-4.33-9.68-9.68-9.68h-11.32c-5.32,0-9.64-4.32-9.64-9.64v-19.1c0-5.32,4.32-9.64,9.64-9.64h11.32c5.34,0,9.68-4.33,9.68-9.68v-19.06h-45.97l-.13,86h46.09Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M268.62,90.72c-2.27-3.99-1.9-8.77.55-12.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M274.15,83.78l-.58-15.83c-.05-1.49,2.11-1.8,2.48-.36,0,0,3.93,15.34,3.93,15.34.88,4.24-5.47,5.17-5.83.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M279.98,93.35l-3.93,15.34c-.38,1.44-2.53,1.12-2.48-.36,0,0,.58-15.83.58-15.83.36-4.32,6.71-3.41,5.83.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M288.99,101.82h3.4v6.88c0,3.58-2.91,6.49-6.49,6.49h0c-1.48,0-2.68-1.2-2.68-2.68v-4.93c0-3.18,2.58-5.77,5.77-5.77Z",
    transform: "translate(179.3 396.32) rotate(-90)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 290.89,
    cy: 38.62,
    r: 11.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 278.61,
    y: 29.67,
    width: 3.96,
    height: 8.78,
    rx: 1.98,
    ry: 1.98,
    transform: "translate(314.66 -246.53) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 246.17,
    cy: 120.7,
    r: 15.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 225.84,
    y: 109.83,
    width: 16.81,
    height: 18.24,
    transform: "translate(-15.5 200.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 193.75,
    y: 49.3,
    width: 25.17,
    height: 54.27,
    rx: 12.58,
    ry: 12.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M213.4,75.56h0c6.95,0,12.58,5.64,12.58,12.58v28.11c0,2.44-1.98,4.42-4.42,4.42h-16.33c-2.44,0-4.42-1.98-4.42-4.42v-28.11c0-6.95,5.64-12.58,12.58-12.58Z",
    transform: "translate(-6.87 179.64) rotate(-45)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M312.16,22.32h8.31v38.4c0,4.96-4.02,8.98-8.98,8.98h0c-4.96,0-8.98-4.02-8.98-8.98v-28.75c0-5.33,4.32-9.65,9.65-9.65Z",
    transform: "translate(357.51 -265.48) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M305.7,79.29c-5.37,0-9.77-4.4-9.77-9.77h0c0-5.38,4.4-9.77,9.77-9.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M305.7,112.24c-5.37,0-9.77-4.4-9.77-9.77h0c0-5.38,4.4-9.77,9.77-9.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M284.3,53.71h0c6.27,0,11.36,5.09,11.36,11.36v2.01h-9.94c-3.18,0-5.77-2.58-5.77-5.77v-3.26c0-2.4,1.95-4.34,4.34-4.34Z",
    transform: "translate(348.2 -227.42) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 329.9,
    cy: 85.7,
    r: 14.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 348.77,
    cy: 85.7,
    r: 19.76
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 332.28,
    cy: 64.86,
    r: 15.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 337.03,
    cy: 53.63,
    r: 12.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 337.03,
    cy: 114.17,
    r: 12.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 347.17,
    cy: 62.89,
    r: 13.49
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 332.28,
    cy: 101.48,
    r: 15.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 347.17,
    cy: 103.17,
    r: 13.49
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 356.83,
    cy: 73,
    r: 9.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 356.83,
    cy: 93.97,
    r: 9.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 323.36,
    cy: 115.27,
    r: 8.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 323.36,
    cy: 51.39,
    r: 8.26
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M312.59,91.34c1.39-.58,1.39-2.54,0-3.13-5.43-2.28-19.03-6.26-26.87-6.26-6.7,0-7.18,7.82-7.18,7.82,0,0,.48,7.82,7.18,7.82,7.85,0,21.45-3.98,26.87-6.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M163.98,20.29h7.64c4.71,0,8.53,3.82,8.53,8.53v92.6c0,4.71-3.82,8.53-8.53,8.53h-7.64V20.29h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M45.51,4.26h104.02c7.67,0,13.9,6.23,13.9,13.9v99.08c0,16.36-13.29,29.65-29.65,29.65H61.26c-16.36,0-29.65-13.29-29.65-29.65V18.15c0-7.67,6.23-13.9,13.9-13.9Z",
    transform: "translate(173.08 -21.95) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 42.9,
    y: 6.84,
    width: 7.75,
    height: 136.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 68.63,
    y: 6.84,
    width: 7.75,
    height: 136.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 94.35,
    y: 6.84,
    width: 7.75,
    height: 136.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 120.08,
    y: 6.84,
    width: 7.75,
    height: 136.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 145.09,
    y: 6.84,
    width: 7.75,
    height: 136.17
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLev3);
export default __webpack_public_path__ + "static/media/lev_3.9733f0ba42e09d0cf86abfb0ab2eb66f.svg";
export { ForwardRef as ReactComponent };